import type { OrganisationSubscription } from '../domain-types';

function sourceLabel(subscription: OrganisationSubscription): string {
  return subscription.source === 'gift' ? 'Gifted access' : 'Organisation subscription';
}

export function PurchasesPanel({
  subscriptions,
  accessUntil,
}: {
  subscriptions: OrganisationSubscription[];
  accessUntil?: string;
}) {
  const hasRecordedAccess = subscriptions.length > 0 || Boolean(accessUntil);

  return (
    <section aria-labelledby="purchases-title" className="purchases-panel" id="purchases">
      <div className="workspace-heading">
        <div>
          <p className="eyebrow">Ecommerce</p>
          <h2 id="purchases-title">Purchases</h2>
        </div>
        <span>Personal</span>
      </div>
      {!hasRecordedAccess ? (
        <p className="empty-state">
          No purchases or gifted access have been recorded for this account.
        </p>
      ) : (
        <div className="purchase-list">
          {subscriptions.map((subscription) => (
            <article className="purchase-card" key={subscription.id}>
              <div>
                <strong>{sourceLabel(subscription)}</strong>
                <span>{subscription.status.replaceAll('_', ' ')}</span>
                {subscription.giftReason ? <p>{subscription.giftReason}</p> : null}
              </div>
              <dl>
                <div>
                  <dt>Access starts</dt>
                  <dd>{new Date(subscription.accessStartsAt).toLocaleDateString('en-AU')}</dd>
                </div>
                <div>
                  <dt>Access until</dt>
                  <dd>{new Date(subscription.accessEndsAt).toLocaleDateString('en-AU')}</dd>
                </div>
              </dl>
            </article>
          ))}
          {subscriptions.length === 0 && accessUntil ? (
            <article className="purchase-card">
              <div>
                <strong>Current organisation access</strong>
                <span>Active</span>
                <p>This access predates the itemised purchase history.</p>
              </div>
              <dl>
                <div>
                  <dt>Access until</dt>
                  <dd>{new Date(accessUntil).toLocaleDateString('en-AU')}</dd>
                </div>
              </dl>
            </article>
          ) : null}
        </div>
      )}
    </section>
  );
}
